import { useActiveWorkspace } from "./useActiveWorkspace";

export type FeatureFlags = {
  ubbBeta: boolean;
  friendOfCsb: boolean;
};

export const useWorkspaceFeatureFlags = (): FeatureFlags => {
  const workspace = useActiveWorkspace();

  return workspace?.featureFlags ?? { ubbBeta: false, friendOfCsb: false };
};
